export default __webpack_public_path__ + "static/va-db5e8af0175d10015b249ff042d60086.svg";